<template>
	<ViewPhoto
		v-if="imageShow && photos.length"
		:key="photosIndex"
		:images="photos"
		:index="photosIndex"
		@close="imageShow = false"
	/>
	<div :class="isEditModal ? 'side-over--active' : ''">
		<div
			v-if="isEditModal"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="isEditModal = false"
		></div>
		<EditGoalSideOver
			v-model:data="editData"
			v-model:error="errorEdit"
			v-model:skills="skills"
			v-model:tab-active="tabActive"
			:is-group="true"
			:show="isEditModal"
			@close="closeModal"
			@submit="editSubmit"
			@updatedActivity="updatedActivity"
		/>
	</div>
	<div
		v-if="!isLoading"
		class="__goal-management-student-detail p-10 md-down:px-4"
	>
		<div
			class="
				__breadcrumbs
				text-sm text-neutral-500
				font-semibold
				flex-nowrap flex
				items-center
				justify-between
			"
		>
			<div>Xem kết quả mục tiêu</div>
			<button
				class="
					button-p
					text-center
					w-fit
					btn--text
					text-neutral-500
					hover:text-neutral-600
				"
				type="button"
				@click="exit"
			>
				<svg
					class="mr-2 text-neutral-400"
					fill="none"
					height="16"
					viewBox="0 0 16 16"
					width="16"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
						fill="currentColor"
					/>
					<path
						d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
						fill="currentColor"
					/>
				</svg>
				Thoát
			</button>
		</div>
		<div class="__goal-management-student-detail__header pt-5">
			<div v-if="groupClass" class="flex gap-6">
				<UserGroup
					:data="groupClass?.students"
					class="mt-2"
					placement="bottom-start"
				/>
				<div>
					<div class="text-neutral-700 font-bold text-4xl">
						{{ groupClass?.name }}
					</div>
					<div class="uppercase text-green-500 font-semibold">
						{{ groupClass?.students?.length }} học sinh
					</div>
				</div>
			</div>
		</div>
		<div class="bg-white shadow-sm rounded-2xl mt-12">
			<div class="flex items-center justify-between p-6">
				<div class="font-semibold text-neutral-600">
					Nội dung mục tiêu
				</div>
				<button
					v-if="goal?.editable"
					class="
						button-p
						text-center
						bg-none
						shadow-none
						flex
						items-center
						justify-center
						btn--text
						w-fit
					"
					type="button"
					@click="editGoalModal(0)"
				>
					<svg
						class="mr-2"
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clip-rule="evenodd"
							d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z"
							fill="currentColor"
							fill-rule="evenodd"
						/>
					</svg>
					Chỉnh sửa
				</button>
			</div>
			<div class="px-6 pb-6">
				<div class="border p-4 rounded-lg">
					<div
						class="
							flex
							items-center
							md-down:flex-col md-down:items-start
						"
					>
						<div
							class="w-1/5 text-neutral-400 font-semibold text-xs"
							style="min-width: 200px; width: 200px"
						>
							NỘI DUNG
						</div>
						<div
							class="text-neutral-600 font-semibold"
							v-html="goal?.name"
						></div>
					</div>
					<div
						class="
							flex
							items-center
							mt-6
							md-down:flex-col md-down:items-start
						"
					>
						<div
							class="w-1/5 text-neutral-400 font-semibold text-xs"
							style="min-width: 200px; width: 200px"
						>
							LĨNH VỰC
						</div>
						<div class="text-neutral-600">
							{{ goal?.skill?.name }}
						</div>
					</div>
					<div
						v-if="org.enable_goal_assistance_level"
						class="flex mt-6 md-down:flex-col items-start"
					>
						<div
							class="
								w-1/5
								text-neutral-400
								font-semibold
								text-xs
								mt-2
							"
							style="min-width: 200px; width: 200px"
						>
							MỨC ĐỘ HỖ TRỢ
						</div>
						<div>
							<div
								v-for="ass in goal?.assistance_levels"
								:key="ass"
								class="text-neutral-600 mb-2"
							>
								{{ ass || '-' }}
							</div>
						</div>
					</div>
					<div
						v-if="org.enable_goal_reason"
						class="
							flex
							items-center
							mt-6
							md-down:flex-col md-down:items-start
						"
					>
						<div
							class="w-1/5 text-neutral-400 font-semibold text-xs"
							style="min-width: 200px; width: 200px"
						>
							CƠ SỞ HỢP LÝ
						</div>
						<div class="text-neutral-600">
							{{ goal?.reason || '-' }}
						</div>
					</div>
					<div
						v-if="org.enable_goal_strategy"
						class="
							flex
							items-center
							mt-6
							md-down:flex-col md-down:items-start
						"
					>
						<div
							class="w-1/5 text-neutral-400 font-semibold text-xs"
							style="min-width: 200px; width: 200px"
						>
							CHIẾN LƯỢC
						</div>
						<div class="text-neutral-600">
							{{ goal?.strategy || '-' }}
						</div>
					</div>
					<div
						v-if="org.enable_goal_process"
						class="
							flex
							items-center
							mt-6
							md-down:flex-col md-down:items-start
						"
					>
						<div
							class="w-1/5 text-neutral-400 font-semibold text-xs"
							style="min-width: 200px; width: 200px"
						>
							QUY TRÌNH THỰC HIỆN
						</div>
						<div
							class="text-neutral-600"
							style="white-space: pre-wrap; word-wrap: break-word"
							v-html="goal?.process"
						></div>
					</div>
				</div>
			</div>
		</div>
		<div class="relative my-12">
			<div aria-hidden="true" class="absolute inset-0 flex items-center">
				<div class="w-full border-t border-neutral-300" />
			</div>
			<div class="relative flex justify-center">
				<div
					class="
						px-2.5
						py-1
						bg-body
						text-neutral-600
						font-semibold
						pb-1
						text-2xl
					"
				>
					Media của mục tiêu
				</div>
			</div>
		</div>
		<div v-if="goal?.goal_media?.length">
			<div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
				<div
					v-for="i in countMedia(goal)"
					:key="i"
					class="rounded-lg bg-neutral-200 relative"
					style="aspect-ratio: 1"
					@click="openMediaPopup(goal?.goal_media, i - 1)"
				>
					<img
						v-if="goal?.goal_media[i - 1]?.asset_type === 'image'"
						:src="loadImage(goal?.goal_media[i - 1])"
						alt=""
						class="rounded-lg object-cover shadow-lg"
						style="aspect-ratio: 1; height: 100%"
					/>
					<img
						v-else-if="loadThumbnail(goal?.goal_media[i - 1])"
						:src="loadThumbnail(goal?.goal_media[i - 1])"
						alt=""
						class="rounded-lg object-cover shadow-lg"
						style="aspect-ratio: 1; height: 100%"
					/>
					<div v-else class="relative">
						<img
							alt=""
							class="rounded-lg object-cover shadow-lg"
							src="../../assets/images/background/auth.png"
							style="aspect-ratio: 1; height: 100%"
						/>
					</div>
					<div class="absolute inset-0 bg-black opacity-20"></div>
					<div
						v-if="goal?.goal_media[i - 1]?.asset_type === 'video'"
						class="absolute flex flex-col items-center"
						style="
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						"
					>
						<svg
							fill="none"
							height="55"
							viewBox="0 0 55 55"
							width="55"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g opacity="0.5">
								<rect
									fill="black"
									height="54.5"
									rx="27.25"
									width="54.5"
								/>
								<path
									d="M34.4948 28.5672L24.9024 36.9606C23.7709 37.9507 22 37.1471 22 35.6436V18.8568C22 17.3532 23.7709 16.5497 24.9024 17.5397L34.4948 25.9332C35.2917 26.6304 35.2917 27.8699 34.4948 28.5672Z"
									fill="white"
								/>
							</g>
						</svg>
					</div>
					<div
						v-if="goal?.goal_media[i - 1]?.inserted_at"
						class="
							absolute
							bottom-2
							left-4
							z-10
							font-medium
							text-white
						"
					>
						{{
							$filters.formatDate(
								goal?.goal_media[i - 1]?.inserted_at
							)
						}}
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="text-center text-neutral-500">
				Mục tiêu này hiện chưa có hình ảnh / video nào được tải lên.
			</div>
		</div>
		<div class="relative my-12">
			<div aria-hidden="true" class="absolute inset-0 flex items-center">
				<div class="w-full border-t border-neutral-300" />
			</div>
			<div class="relative flex justify-center">
				<div
					class="
						px-2.5
						py-1
						bg-body
						text-neutral-600
						font-semibold
						pb-1
						text-2xl
					"
				>
					Hoạt động
				</div>
			</div>
		</div>
		<div class="md:hidden flex items-center justify-end mb-6">
			<button
				class="button-p text-center bg-none shadow-none btn--text w-fit"
				type="button"
				@click="editGoalModal(1)"
			>
				<svg
					class="mr-2"
					fill="none"
					height="16"
					viewBox="0 0 16 16"
					width="16"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						clip-rule="evenodd"
						d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z"
						fill="currentColor"
						fill-rule="evenodd"
					/>
				</svg>
				Chỉnh sửa
			</button>
		</div>
		<div
			v-if="goal?.group_activities?.length"
			class="shadow-sm sm:rounded-2xl overflow-hidden"
		>
			<div class="__record__table overflow-x-auto scroll-bar">
				<div class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full">
					<table class="min-w-full divide-y text-neutral-200">
						<thead class="bg-neutral-100 h-16">
							<tr>
								<th
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										w-16
										whitespace-nowrap
									"
									scope="col"
								>
									STT
								</th>
								<th
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
									"
									scope="col"
								>
									HOẠT ĐỘNG
								</th>
								<th
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
										relative
									"
									scope="col"
								>
									SỐ LẦN ĐƯỢC DẠY
									<button
										class="
											md-down:hidden
											button-p
											text-center
											bg-none
											shadow-none
											flex
											items-center
											justify-center
											btn--text
											w-fit
											absolute
											right-8
											top-1/2
										"
										style="transform: translateY(-50%)"
										type="button"
										@click="editGoalModal(1)"
									>
										<svg
											class="mr-2"
											fill="none"
											height="16"
											viewBox="0 0 16 16"
											width="16"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z"
												fill="currentColor"
												fill-rule="evenodd"
											/>
										</svg>
										Chỉnh sửa
									</button>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(activity, i) in goal?.group_activities"
								:key="activity.id"
								:class="
									i % 2 === 0 ? 'bg-white' : 'bg-neutral-50'
								"
								class="text-neutral-700"
							>
								<td
									class="
										px-6
										py-4
										whitespace-nowrap
										text-neutral-700
									"
								>
									<div class="ml-2">
										{{ i + 1 }}
									</div>
								</td>
								<td
									class="px-6 py-4 text-neutral-700"
									style="width: 50%; min-width: 220px"
								>
									<div class="flex items-center">
										{{ activity.name }}
									</div>
								</td>
								<td class="px-6 py-4 text-neutral-700">
									<div class="flex items-center">
										{{
											activity.group_activity_used_count ||
											0
										}}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div v-else class="flex items-center justify-center flex-col">
			<div class="text-center text-neutral-500">
				Mục tiêu này hiện chưa có hoạt động nào được thêm vào.
			</div>
		</div>
		<div class="relative my-12">
			<div aria-hidden="true" class="absolute inset-0 flex items-center">
				<div class="w-full border-t border-neutral-300" />
			</div>
			<div class="relative flex justify-center">
				<div
					class="
						px-2.5
						py-1
						bg-body
						text-neutral-600
						font-semibold
						pb-1
						text-2xl
					"
				>
					Lịch sử của mục tiêu
				</div>
			</div>
		</div>
		<div class="mt-14">
			<div v-if="goal?.completed_at" class="relative mt-12">
				<div
					aria-hidden="true"
					class="absolute inset-0 flex items-center"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex items-center justify-between mb-2">
					<span
						class="
							pr-3
							bg-body
							text-lg
							font-semibold
							text-neutral-600
						"
					>
						{{ $filters.formatDate(goal?.completed_at) }}
					</span>
					<div
						class="pl-3 bg-body text-neutral-600 flex items-center"
					>
						<span class="mr-2">Hoàn thành mục tiêu</span>
						<svg
							fill="none"
							height="20"
							viewBox="0 0 20 20"
							width="20"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								clip-rule="evenodd"
								d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.0379 6.21209C14.6718 5.84597 14.0782 5.84597 13.7121 6.21209C13.7032 6.22093 13.6949 6.23029 13.6872 6.24013L9.34673 11.7709L6.72983 9.15403C6.36372 8.78791 5.77012 8.78791 5.40401 9.15403C5.03789 9.52015 5.03789 10.1137 5.40401 10.4799L8.71207 13.7879C9.07818 14.154 9.67178 14.154 10.0379 13.7879C10.046 13.7798 10.0537 13.7712 10.0609 13.7622L15.0512 7.52434C15.404 7.15727 15.3995 6.57371 15.0379 6.21209Z"
								fill="#2AA797"
								fill-rule="evenodd"
							/>
						</svg>
					</div>
				</div>
			</div>
			<div v-for="(assStop, index) in assessmentsAfterStop" :key="index">
				<div class="mt-10">
					<div class="font-semibold text-neutral-600 text-lg">
						{{ assStop.tag }}
					</div>
				</div>
				<div class="shadow-sm sm:rounded-2xl overflow-hidden mt-8">
					<div class="overflow-x-auto scroll-bar">
						<div
							class="
								overflow-hidden
								sm:rounded-t-2xl
								w-fit
								min-w-full
							"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
												w-16
											"
											scope="col"
										>
											STT
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
										>
											Ngày
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												whitespace-nowrap
												tracking-wider
											"
											scope="col"
										>
											Kết quả
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
										>
											Cảm xúc
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
											style="width: 350px"
										>
											Hoạt động
										</th>
										<th
											class="
												px-3
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
											style="width: 100px"
										>
											ALBUM
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
											style="width: 350px"
										>
											Ghi chú
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											assessments, index
										) in assStop.assessments"
										:key="index"
										:class="
											index % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700"
									>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div class="ml-4">
												{{ index + 1 }}
											</div>
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
											style="width: 150px"
										>
											<div>
												{{
													$filters.formatDate2(
														assessments
															.lesson_report.date
													)
												}}
											</div>
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
											style="width: 150px"
										>
											<div>
												<div
													:style="{
														background:
															$filters.tagResult(
																assessments.result
															)?.background,
														color: $filters.tagResult(
															assessments.result
														)?.color,
													}"
													class="
														mt-1
														py-0.5
														px-2.5
														rounded-full
														text-neutral-700
														h-fit
														w-fit
														font-semibold
														text-sm
														shadow-input
													"
												>
													{{ assessments.result }}
												</div>
											</div>
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
											style="width: 100px"
										>
											<div>
												<div class="whitespace-normal">
													<img
														v-if="
															assessments
																.lesson_report
																.emotion_scale
														"
														:src="
															require(`@/assets/images/emoji/${
																$filters.emoji(
																	assessments
																		.lesson_report
																		.emotion_scale +
																		''
																).emoji
															}`)
														"
														alt=""
														height="30"
														width="30"
													/>
												</div>
											</div>
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div>
												<div
													v-if="
														assessments.activities
													"
												>
													<div
														v-for="a in assessments.activities"
														:key="a.id"
														class="mb-2"
													>
														{{ a.name }}
													</div>
												</div>
											</div>
										</td>
										<td
											class="
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div
												v-if="
													haveMediaByLessonId(
														assessments
															?.lesson_report?.id
													)
												"
												class="pl-5 py-4"
												@click="
													openMediaPopup(
														[
															haveMediaByLessonId(
																assessments
																	?.lesson_report
																	?.id
															),
														],
														0
													)
												"
											>
												<svg
													fill="none"
													height="20"
													viewBox="0 0 20 20"
													width="20"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														clip-rule="evenodd"
														d="M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z"
														fill="#E5A42B"
														fill-rule="evenodd"
													/>
													<path
														clip-rule="evenodd"
														d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
														fill="#E5A42B"
														fill-rule="evenodd"
													/>
												</svg>
											</div>
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
											style="
												width: 300px;
												min-width: 300px;
											"
										>
											<div>
												<div class="whitespace-normal">
													{{ assessments.note }}
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-14">
			<div v-if="goal?.stopped_at" class="relative mt-12">
				<div
					aria-hidden="true"
					class="absolute inset-0 flex items-center"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex items-center justify-between mb-2">
					<span
						class="
							pr-3
							bg-body
							text-lg
							font-semibold
							text-neutral-600
						"
					>
						{{ $filters.formatDate(goal?.stopped_at) }}
					</span>
					<div
						class="pl-3 bg-body text-neutral-600 flex items-center"
					>
						<span class="mr-2">Tạm dừng mục tiêu</span>
						<svg
							fill="none"
							height="20"
							viewBox="0 0 20 20"
							width="20"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								clip-rule="evenodd"
								d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.83333 9.16667C5.48816 9.16667 5.20833 9.53976 5.20833 10C5.20833 10.4602 5.48816 10.8333 5.83333 10.8333H14.5833C14.9285 10.8333 15.2083 10.4602 15.2083 10C15.2083 9.53976 14.9285 9.16667 14.5833 9.16667H5.83333Z"
								fill="#E37056"
								fill-rule="evenodd"
							/>
						</svg>
					</div>
				</div>
			</div>
			<div v-for="ass in assessments" :key="ass.tag">
				<div class="mt-10">
					<div class="font-semibold text-neutral-600 text-lg">
						{{ ass.tag }}
					</div>
				</div>
				<div class="shadow-sm sm:rounded-2xl overflow-hidden mt-8">
					<div class="overflow-x-auto scroll-bar">
						<div
							class="
								overflow-hidden
								sm:rounded-t-2xl
								w-fit
								min-w-full
							"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
										>
											Tuần
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
											style="width: 350px"
										>
											Hoạt động
										</th>
										<th
											class="
												px-3
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
											style="width: 100px"
										>
											ALBUM
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											aByWeek, index
										) in ass.group_activities_group_by_week"
										:key="index"
										:class="
											index % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700"
									>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											{{ aByWeek.week }}
										</td>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div>
												<div
													v-if="
														aByWeek.group_activities
															?.length
													"
												>
													<div
														v-for="a in aByWeek.group_activities"
														:key="a.id"
														class="mb-2"
													>
														{{ a.name }}
													</div>
												</div>
											</div>
										</td>
										<td
											class="
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div
												v-if="
													aByWeek.goal_media?.length
												"
												class="pl-5 py-4"
												@click="
													openMediaPopup(
														aByWeek.goal_media,
														0
													)
												"
											>
												<svg
													fill="none"
													height="20"
													viewBox="0 0 20 20"
													width="20"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														clip-rule="evenodd"
														d="M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z"
														fill="#E5A42B"
														fill-rule="evenodd"
													/>
													<path
														clip-rule="evenodd"
														d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
														fill="#E5A42B"
														fill-rule="evenodd"
													/>
												</svg>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else class="fixed top-1/2 left-1/2">
		<Loading />
	</div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Loading from '@/components/common/Loading';
import { $api } from '@/services';
import UserGroup from '@/components/elements/UserGroup.vue';
import ViewPhoto from '@/components/common/ViewPhoto.vue';
import EditGoalSideOver from '@/views/createGoalByLibForGroup/EditGoalForGroup.vue';

export default defineComponent({
	components: { EditGoalSideOver, ViewPhoto, UserGroup, Loading },

	setup() {
		const route = useRoute();
		const router = useRouter();
		const store = useStore();
		const groupId = ref(route.params.id);
		const goalId = ref(route.params.goal_id);
		const goal = ref(null);
		const groupClass = ref(null);
		const imageShow = ref(false);
		const isLoading = ref(true);
		const isEditModal = ref(false);
		const photosIndex = ref(0);
		const photos = ref([]);
		const assessments = ref([]);

		const errorEdit = ref(null);
		const skills = ref([]);
		const editData = ref(null);
		const tabActive = ref(null);

		function closeModal() {
			isEditModal.value = false;
		}

		async function editSubmit(data) {
			try {
				const res = await $api.goal.updateGoalGroupClass(
					String(groupId.value),
					data.id,
					{
						group_goal: data,
					}
				);
				if (res?.data) {
					closeModal();
					await fetchGoal();
					await store.dispatch('setAlertMessage', {
						message: 'Chỉnh sửa mục tiêu thành công',
					});
				}
			} catch (e) {
				errorEdit.value = e?.response?.data?.errors_by_field || '';
			}
		}

		async function editGoalModal(tab = 0) {
			tabActive.value = tab;
			editData.value = {
				id: String(goalId.value || ''),
				name: goal.value?.name,
			};
			isEditModal.value = true;
		}

		async function updatedActivity() {
			await fetchGoal();
		}

		function exit() {
			router.go(-1);
		}

		async function fetchGoal() {
			try {
				const { data } = await $api.groupClasses.goalDetail(
					String(groupId.value),
					String(goalId.value),
					{}
				);
				if (data?.data) {
					goal.value = data?.data;
					assessments.value = [
						...goal.value.list_group_lesson_activities
							?.before_stops,
						...goal.value.list_group_lesson_activities?.after_stops,
					];
				}
			} catch (e) {
				console.log(e);
			} finally {
				isLoading.value = false;
			}
		}

		async function fetchGroupClassDetail() {
			try {
				const {
					data: { data },
				} = await $api.groupClasses.detail(String(groupId.value));
				groupClass.value = data;
			} catch (e) {
				console.log(e);
			}
		}

		function countMedia(g) {
			return g?.goal_media >= 6 ? 6 : g?.goal_media?.length;
		}

		function openMediaPopup(media, index) {
			imageShow.value = true;
			photos.value = media;
			photosIndex.value = index;
		}

		function haveMediaByLessonId(lessonId) {
			return goal.value?.goal_media?.find(
				(item) => item.group_lesson_report_id === lessonId
			);
		}

		function loadThumbnail(asset) {
			const imageRequest = JSON.stringify({
				bucket: asset.image_bucket,
				key: asset.video_poster_asset_key,
				edits: {
					width: 400,
					height: 400,
				},
			});
			return `${asset.image_cloudfront_url}/${btoa(imageRequest)}`;
		}

		function loadImage(asset) {
			const imageRequest = JSON.stringify({
				bucket: asset.image_bucket,
				key: asset.asset_key,
				edits: {
					width: 400,
					height: 400,
				},
			});
			return `${asset.image_cloudfront_url}/${btoa(imageRequest)}`;
		}

		async function fetchSkill() {
			try {
				const res = await $api.goal.allSkills();
				if (res?.data) {
					skills.value = res?.data?.data;
				}
			} catch (e) {
				console.log(e);
			}
		}

		fetchGroupClassDetail();
		fetchGoal();
		fetchSkill();

		return {
			isLoading,
			imageShow,
			photosIndex,
			photos,
			isEditModal,
			errorEdit,
			editData,
			skills,
			tabActive,
			closeModal,
			editGoalModal,
			editSubmit,
			countMedia,
			openMediaPopup,
			haveMediaByLessonId,
			updatedActivity,
			loadThumbnail,
			loadImage,
			exit,
			org: computed(() => store.state.profile.current_org),
			goal,
			groupClass,
			assessments,
		};
	},
});
</script>
